import axios from 'axios'
import { store } from '../../App';
// const baseURL = 'http://localhost:8080/api/v1'
const baseURL = process.env.REACT_APP_SERVER_URL + '/PortalService'

const $axios = axios.create({
    baseURL,
});

$axios.interceptors.request.use((config) => {
    const user = store?.getState()?.user?.userData || {}
    config.headers['Authorization'] = config.headers['Authorization'] ? config.headers['Authorization'] : `Bearer ${user?.session_token}` || ''

    return config
})

$axios.interceptors.response.use(
    request => {
        return Promise.resolve(request?.data || {})
    },
    error => {
        if((error?.response?.status === 401 || error?.status === 401) && ((error?.config?.url !== ('/login')) && (error?.config?.url !== ('/ChangePassword')))) {
            localStorage.removeItem('idsp')
            window.location.href = '/login'
        } 
        return Promise.reject(error?.response?.data || 'An error occurred')
    }
)

export { $axios };